// Loan eligibility pre-check.
//
// This used to re-implement the entire pricing engine client-side (income
// engine, scoring, interest-rate selection, eligible-amount, fees) — one of
// three copies of the same math (the other two being client-portal and the
// loan-service submit paths), which could and did drift.
//
// It now delegates to the single source of truth on loan-service:
//   POST /loans/staff/apply/:slug?mode=preview
// which runs the exact same engine the commit path uses and returns the quote
// { status, loanAmt, score, interestRate, paymentFreq, paymentObj, reason }
// without persisting anything. See loan-service evaluate* + the shared
// constants served from /v2/config (loan-service/utils/all-constants.js).

import { store } from "../store";
import { fetchRequests } from "../Requests/getRequests";

async function preCheckLoanEligibility(loanType, data) {
    const accessToken = store.getState().staff.accessToken;
    const headers = {
        "authorization": `${accessToken}`,
        "Content-Type": "application/json",
    };

    // The loanType slug maps 1:1 to the backend apply route (loanme, pension,
    // pensioncash, capitalme, cediscredit, investment, employer, salaried,
    // salaried-advance). `mode=preview` runs the engine without persisting.
    return await fetchRequests(
        `/loans/staff/apply/${loanType}`,
        "post",
        headers,
        { mode: "preview" },
        data
    );
}

export {
    preCheckLoanEligibility
}
